module.exports = __webpack_public_path__ + "static/north-building-desktop.021b2759.webp";